(function ($) {
    /* Document ready functions */
    $(document).ready(function () {

      // Hero slider
      var swiper = new Swiper('.images.swiper-container', {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 3500,
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 1500,
        allowTouchMove: false,
      });

      var swiper2 = new Swiper('.slides.swiper-container', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        speed: 1000,
        allowTouchMove: true,
        breakpoints: {
        1280: {
          speed: 600,
        },
        767: {
          speed: 600,
        }
      }
      });

    });

})(jQuery);
